import React from 'react';
import { DetailsList, DetailsListLayoutMode, SelectionMode, ConstrainMode, IColumn, TooltipHost } from '@fluentui/react';

const TeamChannels = ({site}) => {

    const columns: IColumn[] = [
        {
            key: 'displayName',
            name: 'Name',
            fieldName: 'displayName',
            minWidth: 150, 
            maxWidth: 300, 
            isResizable: true
        },
        {
            key: 'type',
            name: 'Type',
            fieldName: 'channelType',
            minWidth: 50, 
            maxWidth: 200, 
            isResizable: true
        },
        {
            key: 'description',
            name: 'Description',
            fieldName: 'description',
            minWidth: 100, 
            maxWidth: 200, 
            isResizable: true,
            onRender: (item) => {
                return <TooltipHost content={item.description}>{item.description}</TooltipHost>
            }
        },
        {
            key: 'url',
            name: 'Url',
            fieldName: 'url',
            minWidth: 500, 
            maxWidth: 600, 
            isResizable: true,
            onRender: (item) => {
                return item.url.startsWith('https://teams.microsoft.com/')
                        ? <TooltipHost content='SharePoint Site has not been created yet.'><a href={item.url} target='_blank'>Team Channel</a></TooltipHost>
                        : item.url && <TooltipHost content={item.url}><a href={item.url} target='_blank'>{item.url}</a></TooltipHost>
            }
        },
    ]

    return(
        <div style={containerStyles}>
            <DetailsList 
                items={site.channels}
                columns={columns}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                selectionMode={SelectionMode.none}
                styles={{root: {width: '100%'}}}
                constrainMode={ConstrainMode.horizontalConstrained}
            />
        </div>
    );
};

const containerStyles = {
    padding: "10px"
}

export default TeamChannels;


// WEBPACK FOOTER //
// ./src/components/EditSite/TeamChannels.js